/* eslint-disable import/no-duplicates */
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const ISO_DATETIME = /^\d{4}-\d{2}-\d{2}T/;

// converte a data do relatorio em Date, ou null quando nao der.
// aceita apenas YYYY-MM-DD e timestamp ISO: o parser do JS leria "06-09-02"
// como 09/06/2002 e a tela mostraria uma data errada em vez do problema
function parseReportDate(date?: string | null): Date | null {
  if (!date) return null;

  if (DATE_ONLY.test(date)) {
    // meio-dia evita o shift de fuso que joga a data para o dia anterior
    const parsed = new Date(`${date}T12:00:00`);
    if (Number.isNaN(parsed.getTime())) return null;
    // new Date rola o mes: "2026-02-31" viraria 03/03/2026
    if (format(parsed, 'yyyy-MM-dd') !== date) return null;
    return parsed;
  }

  if (ISO_DATETIME.test(date)) {
    const parsed = new Date(date);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
}

// formata a data do relatorio; devolve traco quando a data vier invalida
export function formatReportDate(
  date?: string | null,
  pattern = 'dd MMM yyyy',
): string {
  const parsed = parseReportDate(date);
  if (!parsed) return '—';
  return format(parsed, pattern, { locale: ptBR });
}

// o input de data deixa digitar o ano com zeros a esquerda, e "0006-09-02" e
// uma data valida que passa por qualquer checagem de formato. foi assim que a
// data quebrada entrou no banco, entao a validacao tambem exige ano plausivel
const MIN_YEAR = 2000;

// limites do <input type="date">: o proprio navegador recusa fora dessa faixa
export const MIN_REPORT_DATE = `${MIN_YEAR}-01-01`;

export function maxReportDate(): string {
  return format(new Date(), 'yyyy-MM-dd');
}

// usado na validacao dos formularios, antes de mandar a data para a API
export function isValidReportDate(date?: string | null): boolean {
  const parsed = parseReportDate(date);
  return parsed !== null && parsed.getFullYear() >= MIN_YEAR;
}
